import { render, staticRenderFns } from "./OnFittingItem.vue?vue&type=template&id=c257b070&scoped=true"
import script from "./OnFittingItem.vue?vue&type=script&lang=js"
export * from "./OnFittingItem.vue?vue&type=script&lang=js"
import style0 from "./OnFittingItem.vue?vue&type=style&index=0&id=c257b070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c257b070",
  null
  
)

export default component.exports